// @flow
import type { Action } from "redux-action";
import actionCreators from "@modules/profile/actionCreator";
import http from "@http";
import {
  GetMyAbsences,
  GetMyAbsencesSchema,
  GetMyAbsence,
} from "@modules/profile/constants/actions";
import { all, call, put, takeEvery } from "redux-saga/effects";
import { parseSchema } from "@utils/schema";
import { sendSuccessMessage } from "@modules/app/actionCreator";

export function* onGetMyAbsences(): Generator<*, void, Object> {
  try {
    const response = yield call(http.get, "/api/v1/my-details/my-absence");

    yield put(actionCreators.GetMyAbsencesSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetMyAbsencesError(e.response));
  }
}

export function* onGetMyAbsencesSchema(): Generator<*, void, Object> {
  try {
    const schema = yield parseSchema("MyAbsenceDTO");

    yield put(actionCreators.GetMyAbsencesSchemaSuccess(schema));
  } catch (e) {
    yield put(actionCreators.GetMyAbsencesSchemaError(e.response));
  }
}

type MyAbsenceCreationRequest = $Exact<{
  data: ?Object,
}>;

type MyAbsenceEditRequest = $Exact<{
  data: ?Object,
  id: ?number,
}>;

type MyAbsenceGetRequest = $Exact<{
  data: ?Object,
  id: ?number,
}>;

export function* onGetMyAbsence({
  payload,
}: Action<MyAbsenceGetRequest>): Generator<*, void, Object> {
  if (!payload || !payload.id) {
    throw Error("Invalid payload provided");
  }
  try {
    const response = yield call(http.get, `/api/v1/my-details/my-absence/${payload.id}`);

    yield all([put(actionCreators.GetMyAbsenceSuccess(response.data))]);
  } catch (e) {
    yield put(actionCreators.GetMyAbsenceError(e.response));
  }
}

export default function* MyAbsencesSaga(): Generator<*, void, void> {
  yield all([
    takeEvery(GetMyAbsences, onGetMyAbsences),
    takeEvery(GetMyAbsencesSchema, onGetMyAbsencesSchema),
    takeEvery(GetMyAbsence, onGetMyAbsence),
  ]);
}
